import { render } from "./FrequencyCap.vue?vue&type=template&id=0f98ab41"
import script from "./FrequencyCap.vue?vue&type=script&lang=js"
export * from "./FrequencyCap.vue?vue&type=script&lang=js"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__